import {FC} from 'react';
import Information from 'components/Information';
import {useBackend} from 'state/backend';
import {jt, t} from 'ttag';
import {EmployeeRightsCreateBackendData} from '../../types';

type UpgradeMessageProps = {
    className?: string;
};

const UpgradeMessage: FC<UpgradeMessageProps> = ({className}) => {
    const {
        data: {
            userLicense: {displayUpgradeMessage},
        },
    } = useBackend<EmployeeRightsCreateBackendData>();

    if (!displayUpgradeMessage) return null;

    const billingLink = (
        <a href={window.Urls.billing_index()}>{t`Upgrading`}</a>
    );

    return (
        <Information className={className} type="alert">
            {jt`You can get more full access licenses by ${billingLink} to a bigger plan.`}
        </Information>
    );
};

export default UpgradeMessage;
